<vi-input-standalone
  class="flex-1"
  placeholder="{{ '+SERVICE_TOOL.OTHER_ERROR_CODE_FIELD_TITLE' | translate }}"
  [autocomplete]="false"
  [maxInputLength]="32"
  (inputFocus)="gtmService.track('onFocusTextField', 'Other error code', 'serviceTicket')"
  (inputBlur)="gtmService.track('onBlurTextField', 'Other error code', 'serviceTicket')"
  (valueChange)="valueChanged$.next($event)"
  [value]="otherErrorCodeValue"
></vi-input-standalone>
